export const languages = {
    English: 1,   
    Spanish: 2,
    French: 8
}